import { Modal } from "antd";
const Alert = {
    Delete: {
        success: () => {
            Modal.success({
                title: '删除成功',
            });
        },
        error: (Msg: string) => {
            Modal.error({
                title: '错误！',
                content: Msg
            });
        }
    },
    Cancel: {
        success: () => {
            Modal.success({
                title: '撤消成功',
            });
        },
        error: (Msg: string) => {
            Modal.error({
                title: '错误！',
                content: Msg
            });
        }
    }
}
export default Alert